import { useEffect, useState } from "react";
import { getLocale, subscribeLocale } from "@/i18n";

export function useLocale() {
  const [locale, setLocale] = useState(getLocale);
  useEffect(() => subscribeLocale(() => setLocale(getLocale())), []);
  return locale;
}
